import React, { useCallback, useEffect, useState } from 'react'
import './nav.min.css'
import {ReactComponent as MenuIcon} from '../../assets/shared/icon-hamburger.svg'
import {ReactComponent as CloseIcon} from '../../assets/shared/icon-close.svg'
import {Link} from 'react-router-dom'

const Navigation = ({
  links, width, height, design, numbers, active
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState({
    menu: false,
    nav: true
  })
  // console.log(isMenuOpen.menu, isMenuOpen.nav)
  
  // Hide large screen nav on small screens
  const memoizedScreenCheck = useCallback(() => {
    if (window.innerWidth < 1000) {
      setIsMenuOpen({
        menu: false,
        nav: false
      })
    }
  }, [window.innerWidth])

  useEffect(() => {
    memoizedScreenCheck()
  }, [memoizedScreenCheck])

  let showLinks, demo
  isMenuOpen.nav ? showLinks = 'ShowLinks' : showLinks = ''
  return (
  <nav className={`Navigation BG ${showLinks}`}>
    <span className="MobileIcon hide-large margin-bottom">
      {isMenuOpen.menu ?
      <CloseIcon  onClick={() => setIsMenuOpen({menu: false, nav: false})}/> :
      <MenuIcon  onClick={() => setIsMenuOpen({menu: true, nav: true})}/>}
    </span>
    {design && <span className="LineDesign hide-medium hide-small"></span>}
    
    <div className="NavLinks">
      {links.map((link, i) => {
        let isActive = parseInt(active) // Convert to NO incase is string
        if (numbers) {
          // Check if active number passed in is equal to the link index, then set to true or false to be used in class manipulation
          isActive-1 === i ? isActive = 'active' : isActive = 'shit\'s gon real';
          return <MyLink key={i} link={link} active={isActive} number={i}/>
        }
        return <MyLink key={i} link={link} active={isActive}/>
        
      })}
    </div>
      
  </nav>
)}

const MyLink = ({ link, number, active }) => {
  return (
  <>
  <Link to={
    link === 'Home' ? '/' : `/${link.toLowerCase()}`
  } className={`Link ${active}`}>
    {number >= 0 && <span className="LinkNumber margin-right hide-medium hide-small">{`0${number}`}</span>}
    {link}
  </Link>
  {/* <a href="">
    
  </a> */}
  </>
)}

export default Navigation